/*****  API URLs  *****/
const baseUrl:string = 'https://apiservicios.segurnet.com.do/api'

//Polices
export const get_polices:string = `${baseUrl}/service/policies/get`
//export const get_HTMLConditions:string = `${baseUrl}/service/policies/getHTMLConditions`

//Products
export const get_products:string = `${baseUrl}/service/products/get`
//Reclamations
export const get_reclamation:string = `${baseUrl}/service/reclamation/get`
export const get_reclamationByID:string = `${baseUrl}/service/reclamation/save`
export const send_reclamation:string = `${baseUrl}/service/reclamation/getdetails`
//User
export const p_log:string = `${baseUrl}/service/users/login`
export const update_dataUser:string = `${baseUrl}/service/users/update`
//common
export const sendEmail:string = `${baseUrl}/service/sendmail`





interface iApi {
 name: string,
 url: string,
 method: string
}
export const apis: iApi[] = [
 //Login
 { name: 'login', url: `${baseUrl}/service/users/login`, method: 'GET' },
 //Polices
 { name: 'getPolices', url: `${baseUrl}/service/policies/get`, method: 'GET' },
 //Products
 { name: 'getProducts', url: `${baseUrl}/service/products/get`, method: 'GET' },
 //Reclamations
 { name: 'getReclamations', url: `${baseUrl}/service/reclamation/get`, method: 'GET' },
 { name: 'getReclamationsByID', url: `${baseUrl}/service/reclamation/save`, method: 'POST' },
 { name: 'sendReclamations', url: `${baseUrl}/service/reclamation/getdetails`, method: 'POST' }, 
 //User
 { name: 'updateUser', url: `${baseUrl}/service/users/update`, method: 'PUT' },
 //Common
 { name: 'sendEmail', url: `${baseUrl}/service/sendmail`, method: 'POST' }
]